module.exports = {
  // 家具
  furniture: {
    topImage: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667272625506top-image-furniture.png',
    sectionOne: {
      title: '家具图谱一览',
      desc: '我国起居方式，自古至今，可分为席地坐柑垂足坐两大时期。明及清前期的家具达到黄金阶段。',
      image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437049713furniture-history-picture.jpg',
      listData: [
        { title: '从席地坐到垂足坐阶段', content: '唐以前的家具以席和床为起居中心。入唐以后，不仅椅、凳不算罕见，还出现高形的桌案。但跪坐和跌坐当时依然存在。到了宋化，完全进人垂足高坐的时期，各种高形家其匕初步定形。' },
        { title: '明代家具', content: '明及清前期的家具造型，式样纷呈， 常有变化。表面上似乎是能工巧匠， 各抒才智，随心所欲、率尔操斤 ，便成美器；实则不然，任何式样， 都有相当严格的准则法度， 决不是东拼西凑，任意而为的。' },
        { title: '清代家具', content: '清代家具中有一部分直接继承明代式样，并流传始终，称为明式。 到康熙年间出现一些新做法、 新造型和新装饰的家具， 开始有了清式家具。到雍正，乾隆时期材美工良、装饰性很强。' }
      ]
    },
    sectionTwo: {
      title: '家具图集',
      desc: '家具者，虚实相生也，劲挺婉柔，厚着文绮，沉穆清新',
      listData: []
    },
    sectionFive: {
      title: '创意设计内容',
      desc: '通过提取家具的造型语言，应用于现代家居场景的产品创意设计，营造典雅高级的当代居住环境',
      listData: [
        { name: '静椅', author: '中国设计中心 China Design Centre', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437157840furniture-creative design-picture1.jpg' },
        { name: 'The bright red Plastic Classic Loop chair', author: 'Dezeen', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437195399furniture-creative design-picture2.jpg' },
        { name: 'Ching Chair No.2', author: 'Behance', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437207046furniture-creative design-picture3.jpg' },
        { name: '靛蓝竹椅', author: 'Yatzer', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437238861furniture-creative design-picture4.jpg' },
        { name: 'Manarola Decagon Shaped Mirror', author: 'Pinterest', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437250324furniture-creative design-picture5.jpg' },
        { name: 'Lozi design', author: 'Pinterest', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437257713furniture-creative design-picture6.jpg' },
        { name: 'Wooden vases', author: 'Pinterest', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437263946furniture-creative design-picture7.jpg' },
        { name: 'Caleb Woodard Furniture', author: 'Pinterest', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437275257furniture-creative design-picture8.jpg' },
        { name: '创意内容描述', author: 'Pinterest', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437283721furniture-creative design-picture9.jpg' },
        { name: 'Viiu 开瓶器', author: '微信公众号', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437302139furniture-creative design-picture10.jpg' },
        { name: 'Due Porte', author: 'TATE', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437310669furniture-creative design-picture11.jpg' },
        { name: 'Pinterest', author: '花瓣网', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437325534furniture-creative design-picture12.jpg' }
      ]
    }
  },

  // 服装
  clothing: {
    topImage: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667272696863top-image-clothing.png',
    sectionOne: {
      title: '服装图谱一览',
      desc: '中国是一个衣冠大国，有着极其灿烂悠久的服饰历史，中国就已经初步形成了有明确史籍可考的冠服制度',
      image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667273015170history-clothing.png',
      listData: [
        { title: '古代传统服装', content: '中国古代传统服饰主要分为战国、汉、三国、魏晋南北朝、唐、宋、辽、元、明等几个主要时期，包含袍、衣、童服、礼服、褂、裙、衫、袄、半臂、裤、女披、残片等类别。' },
        { title: '近现代服装', content: '近现代服饰主要分为四个时期，晚清流行长袍马褂、小修衣、长裙、旗装、旗鞋；民国时期，男装主要为西装革履与长袍马褂为主，女装以袄裤、袄裙套裤装、旗袍为主。' },
        { title: '少数民族服装', content: '少数民族服饰选取了苗族、壮族、傣族、布依族、彝族、黎族、蒙古族、朝鲜族、藏族九个民族的服饰，就其每个民族服饰的形制、颜色、纹样、工艺进行了一系列的归纳总结。' }
      ]
    },
    sectionTwo: {
      title: '服装',
      desc: '罗衣何飘摇，轻裾随风还。 顾盼遗光彩，长啸气若兰',
      listData: []
    },
    sectionFive: {
      title: '创意设计内容',
      desc: '中国风格服饰，是建立在中国传统文化与东方文化基础上，蕴含大量中国元素并适应全球流行趋势的艺术形式或生活方式。',
      listData: [
        { name: '中国传统刺绣图案', author: '花瓣网', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437435594Clothes & Accessories-creative design-picture1.jpg' },
        { name: '金羽南秋', author: '花瓣网', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437443802Clothes & Accessories-creative design-picture2.jpg' },
        { name: '流苏步摇', author: '花瓣网', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437454038Clothes & Accessories-creative design-picture3.jpg' },
        { name: '刺绣纹祥', author: '花瓣网', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437461073Clothes & Accessories-creative design-picture4.jpg' },
        { name: '国风人物插画', author: '花瓣网', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437467664Clothes & Accessories-creative design-picture5.jpg' },
        { name: '手提莲花灯笼汉服配饰', author: '花瓣网', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437473420Clothes & Accessories-creative design-picture6.jpg' },
        { name: '仙鹤纹祥', author: '花瓣网', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437480705Clothes & Accessories-creative design-picture7.jpg' },
        { name: '汉服设计图', author: '花瓣网', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437494689Clothes & Accessories-creative design-picture8.jpg' },
        { name: '子凉亭金步摇', author: '花瓣网', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437506168Clothes & Accessories-creative design-picture9.jpg' },
        { name: '汉服设计图', author: '花瓣网', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437513438Clothes & Accessories-creative design-picture10.jpg' },
        { name: '汉服饰品设计', author: '花瓣网', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437522469Clothes & Accessories-creative design-picture11.jpg' },
        { name: '《凤化羽》手工錾刻头冠', author: '花瓣网', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437530799Clothes & Accessories-creative design-picture12.jpg' }
      ]
    }
  },

  // 陶瓷
  pottery: {
    topImage: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667272723069top-image-pottery.png',
    sectionOne: {
      title: '陶瓷图谱一览',
      desc: '中国风格陶瓷，承载着深厚的中国传统文化底蕴，融合、再现了多元的艺术形式与各异的工艺智慧',
      image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667273039237history-pottery.png',
      listData: [
        { title: '隋唐前陶瓷', content: '主要分为夏商周、春秋战国和秦汉三个时期。先秦时期多以青铜器为主，夏商周时期的青铜器多作为礼器用于祭祀，春秋战国时期青铜器则多为日用器，且更为精致灵巧。秦汉时期陶俑极为流行，且制作精美，惟妙惟肖。' },
        { title: '隋-金代陶瓷', content: '魏晋南北朝时期陶俑制作简洁精美。唐代以绚丽多彩的三彩俑为代表。五代陶瓷工艺的发展为宋代陶瓷的高度繁荣奠定了基础。宋代北方之汝窑、定窑、钧窑、官窑、耀州窑，南方之龙泉窑、景德镇窑、建窑、吉州窑均富盛名。辽金地区吸收汉族工匠制陶技术，也创造具有民族和地区风格的陶瓷。' },
        { title: ' 元-清代陶瓷', content: '明清两代的陶瓷工艺，在釉彩、纹样、造型、品种等方面都有显著提高，已被推到五彩缤纷、争奇斗艳的新境地。已具备单色釉和三彩、五彩等多个品种。单色釉出现明永乐的甜白、宣德的霁红和霁蓝，清代的洒蓝、茶叶末等。彩瓷则有明清景德镇的青花、斗彩与粉彩，明嘉靖、万历的五彩，清代的珐琅彩、广彩器等。' }
      ]
    },
    sectionTwo: {
      title: '陶瓷图集',
      desc: '韫珠光堪作鉴，纹镂花鸟具传神。盛得朱樱千万颗，满盘琥珀为生辉',
      listData: []
    },
    sectionFive: {
      title: '创意设计内容',
      desc: '中国风格服饰，是建立在中国传统文化与东方文化基础上，蕴含大量中国元素并适应全球流行趋势的艺术形式或生活方式。',
      listData: [
        { name: '长沙窑“展”系列餐具', author: '国家艺术基金2022年度艺术人才培训资助项目', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437629849ceramics-creative design-picture1.jpg' },
        { name: '长沙窑“合”系列餐具', author: '国家艺术基金2022年度艺术人才培训资助项目', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437637195ceramics-creative design-picture2.jpg' },
        { name: '“石青”咖啡具设计', author: '国家艺术基金2022年度艺术人才培训资助项目', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437644499ceramics-creative design-picture3.jpg' },
        { name: '长沙窑创意花瓶设计', author: '国家艺术基金2022年度艺术人才培训资助项目', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437651644ceramics-creative design-picture4.jpg' },
        { name: '长沙窑创意玻璃杯设计', author: '国家艺术基金2022年度艺术人才培训资助项目', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437657616ceramics-creative design-picture5.jpg' },
        { name: '长沙窑香薰盘设计', author: '国家艺术基金2022年度艺术人才培训资助项目', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437664050ceramics-creative design-picture6.jpg' },
        { name: '长沙窑创意调味瓶设计', author: '国家艺术基金2022年度艺术人才培训资助项目', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437672798ceramics-creative design-picture7.jpg' },
        { name: '长沙窑纹饰创意名片夹设计', author: '国家艺术基金2022年度艺术人才培训资助项目', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437682707ceramics-creative design-picture8.jpg' },
        { name: '“镶珠”笔夹与笔筒设计', author: '国家艺术基金2022年度艺术人才培训资助项目', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437690469ceramics-creative design-picture9.jpg' },
        { name: '长沙窑田园禅趣风铃', author: '国家艺术基金2022年度艺术人才培训资助项目', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437699304ceramics-creative design-picture10.jpg' },
        { name: '福寿杯茶具设计', author: '国家艺术基金2022年度艺术人才培训资助项目', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437707506ceramics-creative design-picture11.jpg' },
        { name: '长沙谣·国学启蒙早教机设计', author: '国家艺术基金2022年度艺术人才培训资助项目', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437716543ceramics-creative design-picture12.jpg' }
      ]
    }
  },

  // 手机
  mobile: {
    topImage: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667272747245top-image-mobile.png',
    sectionOne: {
      title: '中国手机发展史',
      desc: '中国手机发展时间进程与各时期概览',
      image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437821340phone-history-picture.jpg',
      listData: [
        { title: '萌芽探索时期', content: '功能机时代，在国家政策的大力扶持下，国产手机迎来的短暂的小高峰——2003年末，国产手机品牌在国内市场份额第一次超过国外品牌，国内市场份额高达55%。' },
        { title: '崛起发展时期', content: '2008年中国的TD-SCDMA技术成为3G三大技术之一。2012年中国手机企业“百花齐放”，被誉为中国智能手机市场元年。随着第四代通讯技术成熟，经过2015年市场洗牌，国内手机市场逐渐形成华为、小米、OPPO、vivo组成的竞争格局。' },
        { title: '自研创新时期', content: '2018年，华为完成了5G核心网安全技术的测试，通过率达到100%。随着5G技术的日益成熟，加快了手机行业的转型发展，促进我国手机行业技术自主研发能力的提升与综合创新能力的发展。' }
      ]
    },
    sectionTwo: {
      title: '中国手机图集',
      desc: '部分中国自主手机品牌代表性机型图集',
      listData: {
        Xiaomi: {
          logo: 'mobile-logo1',
          videoUrl: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667438209914mi-video.mp4',
          mobileList: [
            { name: 'Xiaomi MIX Fold 2', logo: 'LOGO IMAGE', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667438162851Xiaomi MIX Fold 2.png' },
            { name: 'Xiaomi 12S Ultra', logo: 'LOGO IMAGE', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667438172749Xiaomi 12S Ultra.png' }
          ]
        },
        rongyao: {
          logo: 'mobile-logo2',
          videoUrl: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437919881honor-video.mp4',
          mobileList: [
            { name: '荣耀Magic V', logo: 'LOGO IMAGE', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437909282Honor-Magic V.png' },
            { name: '荣耀Magic 4 Pro', logo: 'LOGO IMAGE', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437867682Honor-Magic 4 Pro.png' }
          ]
        },
        huawei: {
          logo: 'mobile-logo3',
          videoUrl: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437958421huawei-video.mp4',
          mobileList: [
            { name: 'HUAWEI Mate Xs 2', logo: 'LOGO IMAGE', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437945202HUAWEI Mate Xs 2.png' },
            { name: 'HUAWEI Mate 50 Pro', logo: 'LOGO IMAGE', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667437933356HUAWEI Mate 50 Pro.png' }
          ]
        },
        vivo: {
          logo: 'mobile-logo4',
          videoUrl: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667438117014vivo-video.mp4',
          mobileList: [
            { name: 'VIVO X Fold+', logo: 'LOGO IMAGE', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667438365601VIVO X Fold.png' },
            { name: 'VIVO X80 Pro', logo: 'LOGO IMAGE', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667438106896VIVO X80 Pro.png' }
          ]
        },
        oppo: {
          logo: 'mobile-logo5',
          videoUrl: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667438054564oppo-video.mp4',
          mobileList: [
            { name: 'OPPO Find N', logo: 'LOGO IMAGE', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667438030624OPPO Find N.png' },
            { name: 'OPPO Find X5 Pro', logo: 'LOGO IMAGE', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667438043181OPPO Find X5 Pro.png' }
          ]
        }
      }
    },
    sectionThree: {
      title: '手机里的中国故事',
      desc: '部分中国自主手机品牌中在文化、设计中的中国元素',
      listData: [
        { index: 1, name: '小米徕卡影像大赛', content: '和罗大佑一起编写《2022中国影像辞典》上传你的感动瞬间', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667438771595mi-creative-picture1.jpg' },
        { index: 2, name: '华为昆仑系列', content: '昆仑破晓，划破苍穹；昆仑霞光，普照万山', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667438844036mi-creative-picture2.jpg' },
        { index: 3, name: 'VIVO华夏红', content: '方圆天阶设计，方形的画布与隐隐金环点缀的圆环相融合，连续曲面工艺浑然一体，以东方意境，诠释科技之美', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667439101985mi-creative-picture5.jpg' },
        { index: 4, name: 'VIVO天圆地方', content: '方圆天阶设计，方形的画布与隐隐金环点缀的圆环相融合，连续曲面工艺浑然一体，以东方意境，诠释科技之美', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667439142300mi-creative-picture4.jpg' },
        { index: 5, name: '华为花意漫城系列手机壳', content: '四城的浪漫花意，跃然而止，由内到外彰显优雅和诗意', image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667439088899mi-creative-picture3.jpg' }
      ]
    }
  },

  // 高铁
  highSpeedRail: {
    topImage: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667272784275top-image-highspeedrail.png',
    sectionOne: {
      title: '列车谱系一览',
      desc: '中国铁路电力动车组发展历程及谱系图',
      image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667273057255history-highspeedrail.png',
      listData: [
        { title: '探索时期', content: '探索期为1960年代至1980年代，少数国家率先研制高速列车并将其投入运营，且这个阶段投入运营车辆数量也较少。' },
        { title: '发展时期', content: '发展期为1990年代至2000年代，世界主要高速列车发展环境基本形成，主要高速列车车型都已开始运营。本时期中，八个国家投入运营高速列车车型从探索期12种增加到64种。' },
        { title: '跨越时期', content: '跨越期为2010年代后，世界高速列车设计与制造技术进入新时期。受到世界经济大环境影响和各国间对新型列车研发目标越来越明确等原因影响下，各个国家新投入运营车型数量明显减少。' }
      ]
    },
    sectionTwo: {
      title: '列车图集',
      desc: '部分绘制干线动车组矢量图案',
      listData: []
    },
    sectionThree: {
      title: '镜头下的列车',
      desc: '来自铁路爱好者的列车摄影作品',
      rail: {
        name: '动车组列车',
        content: '跨越四季 | 川流不息',
        image: 'https://sinicism.oss-cn-shenzhen.aliyuncs.com/1667439630170high-speed rail-creative-picture.jpg'
      }
    }
  }
}
